import { render } from "./SubCategoryEdit.vue?vue&type=template&id=779f3b00"
import script from "./SubCategoryEdit.vue?vue&type=script&lang=js"
export * from "./SubCategoryEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__